import { useAuthStore } from '../store/authStore';
import { Permission } from '../types/entities';

export function usePermission() {
  const { user } = useAuthStore();

  const can = (permission: Permission): boolean => {
    if (!user?.permissions) return false;
    return user.permissions.includes(permission);
  };

  const canAny = (permissions: Permission[]): boolean => {
    if (!user?.permissions) return false;
    return permissions.some(p => user.permissions!.includes(p));
  };

  return { can, canAny, permissions: user?.permissions || [] };
}
